import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { Event } from '../models/event';
import { PlayerEventInfo } from '../models/playerEventInfo';
import { EventService } from './event.service';
import { PlayerService } from './player.service';

export interface PlayerManagedMatch {
  eventId: string;
  name: string;
  nextOccurrenceTimestamp: string;
  nextOccurrenceTimestampZone: string;
}
export interface PlayerManagerContext {
  matches: PlayerManagedMatch[];
  event: Event;
  participation: PlayerEventInfo;
}

@Injectable({ providedIn: 'root' })
export class PlayerManagerContextService {
  constructor(private http: HttpClient, private events: EventService, private players: PlayerService) {}

  async prepare(playerId: string, sourceEvent?: Event, selectedId?: string): Promise<PlayerManagerContext | null> {
    const viewerId = this.players.peekCurrentPlayer()?.id;
    if (!viewerId || !playerId || viewerId === playerId || sourceEvent?.active === false) return null;
    const matches = await firstValueFrom(this.http.get<PlayerManagedMatch[]>(
      `${environment.API_BASE_URL}/player/${playerId}/manager-context`));
    if (this.players.peekCurrentPlayer()?.id !== viewerId) throw new Error('Session changed');
    if (selectedId && !matches.some(item => item.eventId === selectedId)) throw new Error('Manager context changed');
    const selected = matches.find(item => item.eventId === (selectedId || sourceEvent?.id)) || matches[0];
    if (!selected) {
      if (sourceEvent?.manager?.id === viewerId) throw new Error('Manager context changed');
      return null;
    }
    const event = await firstValueFrom(this.events.getRichEvent(selected.eventId));
    const participation = event.playerEventInfos?.find(item => item.player?.id === playerId);
    if (this.players.peekCurrentPlayer()?.id !== viewerId || !participation || event.manager?.id !== viewerId
      || event.active !== true || event.cancelled) throw new Error('Manager context changed');
    event.viewedByManager = true;
    return {matches, event, participation};
  }
}
